'use client';

import { createContext, useContext, useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { isCookieTrue } from 'utils/cookies';

const WebAppContext = createContext({
  runningInWebView: false,
  runningInIOS: false,
  runningInAndroid: false,
});

WebAppProvider.propTypes = {
  children: PropTypes.node.isRequired,
  webViewCookies: PropTypes.object.isRequired,
};

export function WebAppProvider({
  children,
  webViewCookies = {
    runningInWebView: false,
    runningInIOS: false,
    runningInAndroid: false,
  },
}) {
  const {
    runningInWebView: webViewFromContext,
    runningInIOS: iosFromContext,
    runningInAndroid: androidFromContext,
  } = webViewCookies;
  const [runningInWebView, setRunningInWebView] = useState(webViewFromContext);
  const [runningInIOS, setRunningInIOS] = useState(iosFromContext);
  const [runningInAndroid, setRunningInAndroid] = useState(androidFromContext);

  // Forgive me, lord, for I have sinned
  useEffect(() => {
    setRunningInWebView(isCookieTrue('runningInWebView'));
    setRunningInIOS(isCookieTrue('runningInIOS'));
    setRunningInAndroid(isCookieTrue('runningInAndroid'));
  }, []);

  const value = useMemo(
    () => ({ runningInWebView, runningInIOS, runningInAndroid }),
    [runningInWebView, runningInIOS, runningInAndroid]
  );

  return (
    <WebAppContext.Provider value={value}>{children}</WebAppContext.Provider>
  );
}

export const useWebApp = () => {
  const { runningInWebView } = useContext(WebAppContext);
  return runningInWebView;
};

export const useIOS = () => {
  const { runningInIOS } = useContext(WebAppContext);
  return runningInIOS;
};
